/**
 * Masks Formie tel inputs to the format (xxx) xxx-xxxx as the user types.
 */
const format = (value) => {
  // Strip everything except 0-9 (this also drops pasted formatting/whitespace
  // and invisible directional-control characters), then cap at 10 digits.
  const digits = value.replace(/\D/g, "").substring(0, 10);
  const len = digits.length;

  if (len === 0) return "";
  if (len < 4) return `(${digits}`;
  if (len < 7) return `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
  return `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
};

const maskInput = (input) => {
  if (input.dataset.phoneMasked) return;
  input.dataset.phoneMasked = "true";

  input.value = format(input.value);

  input.addEventListener("input", () => {
    input.value = format(input.value);
  });
};

const init = (root = document) => {
  root.querySelectorAll(".fui-input[type='tel']").forEach(maskInput);
};

init();

// Catch inputs added after initial load (e.g. ajax-rendered forms).
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType !== Node.ELEMENT_NODE) return;
      if (node.matches?.(".fui-input[type='tel']")) {
        maskInput(node);
      } else {
        init(node);
      }
    });
  });
});

observer.observe(document.body, { childList: true, subtree: true });
